module.exports = __webpack_public_path__ + "img/img-6-m-pass-plan@2x.82f3f2a2.png";